var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".b3684a47-d51f-40ce-9a08-a99332988f6b{fill:#fbb03b;}")),React.createElement("polygon",{"className":"b3684a47-d51f-40ce-9a08-a99332988f6b","points":"17.9 0 10.4 0.1 18.8 8.6 0 8.5 0 13.9 18.9 13.9 10.5 22.2 18 22.3 29.1 11.1 17.9 0","key":1})]);
}

Arrow.defaultProps = {"id":"e064d859-7335-4527-8502-e9ad9260b32d","data-name":"Lager 1","viewBox":"0 0 29.1 22.3"};

module.exports = Arrow;

Arrow.default = Arrow;
